/**
 * this closure provides functions to handle NSN
 * API data to build out the NSN best subjects
 * page in the subject finder
 */
const _nsnMethods = (function () {
    function NSN({ helpers, origin }) {
        /// ///////////////////////////////////////
        // -- private

        /**
         * sets the NSN data content to the
         * NSN results page
         */
        function setNSNData(data) {
            const hasStats = Object.keys(data.stats);
            const bestSubjectsList = document.querySelector(
                `[data-role="best-subjects"]`
            );
            const subjectStats = document.querySelector(
                `[data-role="subject-stats"]`
            );
            const apiBestSubjectsTitle = document.createElement('span');

            bestSubjectsList.innerHTML = '';
            subjectStats.innerHTML = '';

            apiBestSubjectsTitle.textContent = 'What are your best subjects?';
            apiBestSubjectsTitle.dataset.role = 'question';
            apiBestSubjectsTitle.classList.add('hidden');

            bestSubjectsList.before(apiBestSubjectsTitle);

            data.bestSubjects.forEach((subject, i) => {
                const subjectItem = document.createElement('article');
                const subjectItemInput = document.createElement('input');

                // hidden subject fields
                subjectItemInput.type = 'hidden';
                subjectItemInput.name = `nsn-best-subject-${i + 1}`;
                subjectItemInput.value = subject;

                bestSubjectsList.before(subjectItemInput);

                // subject items
                subjectItem.classList.add('subject-finder__subject-item');

                subjectItem.innerHTML = subject;

                bestSubjectsList.append(subjectItem);
            });

            hasStats.forEach((stat) => {
                const statItem = document.createElement('article');

                statItem.classList.add('subject-level');

                if (stat === '01') {
                    statItem.innerHTML = `
                        <span class="subject-level__number">${data.stats[stat]}</span>

                        Level one
                    `;
                } else if (stat === '02') {
                    statItem.innerHTML = `
                        <span class="subject-level__number">${data.stats[stat]}</span>

                        Level two
                    `;
                } else if (stat === '03') {
                    statItem.innerHTML = `
                        <span class="subject-level__number">${data.stats[stat]}</span>

                        Level three
                    `;
                }

                subjectStats.append(statItem);
            });

            window.nsnRetrieved = true;
        }

        /**
         * this function is used for local testing only!
         *
         * It's doing a fake API request and will do a
         * random fail to simulate an API fail
         *
         * @return {void}
         */
        function fauxNSN(nsnNumber, loadingIcon, continueBtn, bestSubjectHr) {
            if (!nsnNumber) return;

            this.paused(true);

            setTimeout(() => {
                const random = Math.floor(Math.random() * 2);

                // successful API fetch
                if (random) {
                    this.include({
                        pages: ['nsn-api-best-subject'],
                    });

                    setTimeout(() => {
                        this.setStart(
                            {
                                page: 'nsn-api-best-subject',
                            },
                            true
                        );
                    }, 0);

                    // this.exclude({
                    // pages: ['best-subjects'],
                    // });

                    this.paused(false);

                    helpers.loadSpinner();

                    continueBtn.append(loadingIcon);

                    const nsnData = {
                        success: true,
                        bestSubjects: [
                            'Furniture',
                            'Electronic Engineering',
                            'Computing',
                            'Mathematics',
                            'Statistics and Probability',
                        ],
                        stats: { '01': 40, '02': 23, '03': 8 },
                        message: 'Subjects returned successfully.',
                    };

                    setNSNData.bind(this)(nsnData);
                    window.nsnRetrieved = true;
                } else {
                    // failed API fetch
                    this.include({
                        pages: ['best-subjects'],
                    });

                    this.exclude({
                        pages: ['nsn-api-best-subject'],
                    });

                    this.paused(false);

                    this.setStart(
                        {
                            page: 'best-subjects',
                        },
                        true
                    );

                    const apiError = document.createElement('span');

                    apiError.dataset.role = 'nsn-fetch-error';

                    if (
                        !document.querySelector(`[data-role="nsn-fetch-error"]`)
                    ) {
                        apiError.textContent =
                            "We couldn't retrieve enough of your subject data from NZQA. Please enter your best subjects below.";

                        bestSubjectHr.after(apiError);
                    }

                    // apiError.textContent =
                    // 'There was a problem fetching your NSN info. Please select your three best subjects below.';

                    // progressBar.after(apiError);

                    helpers.loadSpinner();

                    continueBtn.append(loadingIcon);
                }
            }, 2000);
        }

        /**
         * gets the NSN data and prints out the
         * results
         *
         * @param {int} nsnNumber
         * the NSN number that will be used for the API
         *
         * @return {void}
         */
        function nsnFetch(nsnNumber) {
            const loadingIcon = document.querySelector(
                `[data-spinner="nsn-api-loading"]`
            );
            const continueBtn = document.querySelector(`[data-nav="continue"]`);
            const bestSubjectHr = document.querySelector(
                `[data-role="best-subjects-hr"]`
            );

            loadingIcon.remove();

            helpers.loadSpinner(continueBtn);

            if (window.location.href.match(/localhost/gi)) {
                // FOR LOCAL DEVELOPMENT
                fauxNSN.bind(this)(
                    nsnNumber,
                    loadingIcon,
                    continueBtn,
                    bestSubjectHr
                );
            } else {
                // FOR LIVE DEVELOPMENT
                if (!nsnNumber) return;

                this.paused(true);

                fetch(
                    `${origin}/_design/integration-points/nsn/nsn-get-standards?nsn=${nsnNumber}`,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    }
                )
                    .then((data) => data.json())
                    .then((json) => {
                        window.nsnRetrieved = true;

                        this.include({
                            pages: ['nsn-api-best-subject'],
                        });

                        setTimeout(() => {
                            this.setStart(
                                {
                                    page: 'nsn-api-best-subject',
                                },
                                true
                            );
                        }, 0);

                        this.paused(false);

                        helpers.loadSpinner();

                        continueBtn.append(loadingIcon);

                        setNSNData.bind(this)(json);
                    })
                    .catch((err) => {
                        this.include({
                            pages: ['best-subjects'],
                        });

                        const apiError = document.createElement('span');

                        apiError.dataset.role = 'nsn-fetch-error';

                        if (
                            !document.querySelector(
                                `[data-role="nsn-fetch-error"]`
                            )
                        ) {
                            apiError.textContent =
                                "We couldn't retrieve enough of your subject data from NZQA. Please enter your best subjects below.";

                            bestSubjectHr.after(apiError);
                        }

                        this.include({
                            pages: ['best-subjects'],
                        });

                        this.exclude({
                            pages: ['nsn-api-best-subject'],
                        });

                        this.paused(false);

                        setTimeout(() => {
                            this.setStart(
                                {
                                    page: 'best-subjects',
                                },
                                true
                            );
                        }, 0);

                        helpers.loadSpinner();

                        continueBtn.append(loadingIcon);
                    });
            }
        }

        /// ///////////////////////////////////////
        // -- public

        /**
         * get the NSN endpoint
         */
        this.getNSN = function () {
            const nsnNumberNode =
                this.active.querySelector(`[name="student-nsn"]`);

            if (!nsnNumberNode) return;

            nsnNumberNode.value = nsnNumberNode.value.replace(/^0/, '');

            const nsnNumber = nsnNumberNode.value;
            const { name } = this.activeData;

            if (!nsnNumber) {
                this.include({
                    pages: ['best-subjects'],
                });

                setTimeout(() => {
                    this.setStart({
                        page: 'best-subjects',
                    });
                }, 0);

                return;
            }

            nsnFetch.bind(this)(nsnNumber);
        };
    }

    return (props) => {
        return new NSN(props);
    };
})();

export default _nsnMethods;
